import IconExclamation from '../icons/icon-exclamation/icon-exclamation';
import { IconProps } from '../icons/icon-props-interface';
import Icon from '../icons/icon/icon';
import IconInfo from '../icons/icon-info/icon-info';
import IconWarning from '../icons/icon-warning/icon-warning';
import FontBody2 from '../fonts/font-body2/font-body2';
import './note.scss';
import { FONT_COLOR, FONT_VARIANT } from '../fonts/font-props';

export enum NOTE_TYPE {
	INFORMATION = 'note-information',
	WARNING = 'note-warning',
	ERROR = 'note-error',
}

export interface INoteProps {
    IconComponent?: React.FC<IconProps>;
	type?: NOTE_TYPE;
    caption?: string;
    body: React.ReactNode;
}

export const Note: React.FC<INoteProps> = ({ IconComponent, type = NOTE_TYPE.INFORMATION, caption, body }) => {
    const getIconColor = () => {
        switch (type) {
            case NOTE_TYPE.INFORMATION:
                return 'var(--color-accent-1)';
            case NOTE_TYPE.WARNING:
                return 'var(--color-accent-4)';
            case NOTE_TYPE.ERROR:
                return 'var(--color-accent-3)';
            default:
                return 'var(--color-accent-1)';
        }
    }

    const getCaptionColor = () => {
        switch (type) {
            case NOTE_TYPE.INFORMATION:
                return FONT_COLOR.ACCENT1;
            case NOTE_TYPE.WARNING:
                return FONT_COLOR.ACCENT4;
            case NOTE_TYPE.ERROR:
                return FONT_COLOR.ACCENT3;
            default:
                return FONT_COLOR.ACCENT1;
        }
    }
    
    const getIconComponent = (): React.FC<IconProps> => {
        
        if (IconComponent) {
            return () => <IconComponent color={getIconColor()} />;
        }

        switch (type) {
            case NOTE_TYPE.INFORMATION:
                return () => <IconInfo color={getIconColor()} />;
            case NOTE_TYPE.WARNING:
                return () => <IconWarning color={getIconColor()} />;
            default:
                return () => <IconExclamation color={getIconColor()} />;
            }
    }

    return (
        <div className={`note ${type}`}>
            <Icon Component={getIconComponent()} />
            {caption && 
                <div className="note-caption">
                    <FontBody2 variant={[FONT_VARIANT.UPPERCASE, FONT_VARIANT.BOLD]} color={getCaptionColor()}>
                        {caption}
                    </FontBody2>
                </div>
            }
            <div className="note-body">
                <FontBody2>{body}</FontBody2>
            </div>
        </div>
    )
};
